import {
  Chip,
  colors,
  Grid,
  Icon,
  IconButton,
  Link,
  Typography,
} from "@mui/material";
import { addSeconds } from "date-fns";

import MDBox from "components/MDBox";

import { formatCurrency } from "helpers/utils";
import { formatDate } from "helpers/formatDate";

import { IDetailsPix } from "interfaces/detailsPix";

// icones
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import iconPix from "assets/images/icons/icon-pago-pix.png";
import { siteConfig } from "types/siteConfig";
import { whatsappShare } from "helpers/whatsapp";

interface Props {
  detailsPix: IDetailsPix;
}

export default function DetailsPix({ detailsPix }: Props) {
  function handleWhatsapp() {
    whatsappShare({
      message: `Olá, _${detailsPix.devedor.nome.toUpperCase()}_ segue o PIX copia-e-cola no valor de *${formatCurrency(
        detailsPix.valor.original
      )}*. Cobrança referente à Inscrição.\n\n${detailsPix.pixCopiaECola}\n\n${siteConfig.name}.`,
    });
  }

  return (
    <>
      <MDBox sx={{ my: 3, p: 2, overflowY: "scroll", height: "70vh" }}>
        {/* Barra de status e ações */}
        <MDBox sx={{ display: "flex", justifyContent: "space-between" }}>
          <Chip
            label={detailsPix.status}
            variant="outlined"
            color={detailsPix.status === "CONCLUIDA" ? "success" : "warning"}
          />
          <MDBox sx={{ display: "flex", gap: 1, mt: 1 }}>
            <IconButton onClick={handleWhatsapp}>
              <WhatsAppIcon />
            </IconButton>
          </MDBox>
        </MDBox>

        {/* Detalhes */}
        <MDBox sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <Typography variant="h4" fontWeight="bold">
              Valor da cobrança:
            </Typography>
            <Typography variant="h5" color="orange">
              {formatCurrency(detailsPix.valor.original)}
            </Typography>
          </MDBox>

          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <Typography variant="body2" fontWeight="bold">
              Data criação:
            </Typography>
            <Typography variant="body2" color="GrayText">
              {formatDate(detailsPix.calendario.criacao, "dd/MM/yyyy HH:mm:ss")}
            </Typography>
          </MDBox>

          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <Typography variant="body2" fontWeight="bold">
              Expiração pix:
            </Typography>
            <Typography variant="body2" color="GrayText">
              {formatDate(
                addSeconds(
                  detailsPix.calendario.criacao,
                  detailsPix.calendario.expiracao
                ),
                "dd/MM/yyyy HH:mm:ss"
              )}
            </Typography>
          </MDBox>

          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <Typography variant="body2" fontWeight="bold">
              txid:
            </Typography>
            <Typography variant="body2" color="GrayText">
              {detailsPix.txid}
            </Typography>
          </MDBox>

          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <Typography variant="body2" fontWeight="bold">
              Pagador:
            </Typography>
            <Typography variant="body1" fontWeight="bold" color="GrayText">
              {`${detailsPix.devedor.nome.toUpperCase()} | ${detailsPix.devedor.cpf}`}
            </Typography>
          </MDBox>
        </MDBox>

        {/* Informações do pix */}
        <MDBox
          sx={{
            bgcolor: colors.grey[100],
            p: 2,
            mt: 2,
            borderRadius: 2,
            border: "1px dashed #ccc",
            display: "flex",
            justifyContent: "space-between",
            gap: 3,
          }}
        >
          {/* Informações do pix */}
          <MDBox>
            <Typography variant="body2" fontWeight="bold">
              Informações
            </Typography>

            {detailsPix.infoAdicionais.map((info) => (
              <Typography variant="body2">{info.nome}</Typography>
            ))}

            <Typography variant="body2" sx={{ wordBreak: "break-word", mt: 2 }}>
              {detailsPix.pixCopiaECola}
            </Typography>
          </MDBox>

          {/* Image do pix se estiver pago */}
          {detailsPix.status === "CONCLUIDA" && (
            <MDBox
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                width: 250,
              }}
            >
              <img src={iconPix} width={60} alt="image qrcod pix" />
              <Typography variant="body1" fontWeight="bold" color="GrayText">
                Pix já está pago!
              </Typography>
            </MDBox>
          )}
        </MDBox>

        {/* Dados do pagamento */}
        <MDBox
          sx={{
            bgcolor: colors.grey[100],
            p: 2,
            mt: 2,
            borderRadius: 2,
            border: "1px dashed #ccc",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="body2" fontWeight="bold">
            Dados do pagamento
          </Typography>

          <Grid container spacing={1}>
            {detailsPix.pix?.map((pix) => (
              <>
                <Grid item xs={12} md={2}>
                  <Typography variant="body2" fontWeight="bold">
                    Data/Hora
                  </Typography>
                  <Typography variant="body2">
                    {formatDate(pix.horario, "dd/MM/yyyy HH:mm:ss")}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                  <Typography variant="body2" fontWeight="bold">
                    Código da transação - endToEndId
                  </Typography>
                  <Typography variant="body2">{pix.endToEndId}</Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                  <Typography variant="body2" fontWeight="bold">
                    chave recebeu pix
                  </Typography>
                  <Typography variant="body2">{pix.chave}</Typography>
                </Grid>
              </>
            ))}
          </Grid>
        </MDBox>
      </MDBox>
      <Typography
        variant="subtitle2"
        fontWeight="bold"
        sx={{ mt: 2, mr: 3, textAlign: "right", color: "GrayText" }}
      >
        Criado em:{" "}
        {formatDate(detailsPix.calendario.criacao, "dd/MM/yyyy HH:mm:ss")}
      </Typography>
    </>
  );
}
